export type AcceptFileType = "image/png" | "image/jpeg" | "application/pdf";

/**
 * ファイルアップロード時のエラーモーダルメッセージの一部を作成する
 * @param acceptFileType[] - ファイルアップロード時の許可するファイルタイプの配列
 * @returns string @example "JPG、PNG、PDF" , "JPG、PNG"
 */
export const createSubMessage = (acceptFileTypes: AcceptFileType[]) => {
  const subMessage = acceptFileTypes.map((acceptFileType) => {
    switch (acceptFileType) {
      case "image/jpeg":
        return "JPG";
      case "image/png":
        return "PNG";
      case "application/pdf":
        return "PDF";
    }
  });

  return subMessage.join("、");
};
